export interface RuntimeConfig {
  apiUrl: string;
  userPoolId: string;
  userPoolClientId: string;
  userPoolDomain: string;
  projects: Array<{ id: string; label: string }>;
}

let cached: Promise<RuntimeConfig> | null = null;

export function loadRuntimeConfig(): Promise<RuntimeConfig> {
  cached ??= fetch('/runtime-config.json', { cache: 'no-store' }).then(async (response) => {
    if (!response.ok) throw new Error(`Failed to load runtime-config.json (${response.status})`);
    return response.json() as Promise<RuntimeConfig>;
  });
  return cached;
}
